module.exports = __webpack_public_path__ + "static/media/BZ.0b3efee1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/BZ.svg
// module id = 215
// module chunks = 0